import fetchAPI from '../fetchAPI';

export const callTogglePin = async (
  id: string
): Promise<iResponse<{ isPinned: boolean; pinnedOrder: number }>> => {
  const response: iResponse<{ isPinned: boolean; pinnedOrder: number }> = await fetchAPI({
    method: 'PATCH',
    route: `billing-accounts/${id}/pin`
  });

  return response;
};

export default callTogglePin;
